import { render, staticRenderFns } from "./form.vue?vue&type=template&id=70eafa0a&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=70eafa0a&prod&scoped=true&lang=css"
import style1 from "./form.vue?vue&type=style&index=1&id=70eafa0a&prod&lang=scss"
import style2 from "./form.vue?vue&type=style&index=2&id=70eafa0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eafa0a",
  null
  
)

export default component.exports